export default __webpack_public_path__ + "static/media/timer.32246d74.svg";